












































import { authorClient } from "@/api/index";
import { errorMsg,setCommon } from "@/utils/request";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { ListUserGroupByTypeReq } from "@/pbjs/external/auth/auth_pb";
import { Component, Vue, Provide,Prop,Watch } from "vue-property-decorator";
const deleteDialog = () => import("@/views/peopleManagement/components/deleteDialog.vue");
@Component({
    name: "work",
    components: { deleteDialog }
})
export default class CombinationProperty extends Vue {
    @Prop() baseUserInfo: any;
    @Prop() workAdd: any;
    @Prop() workDetail: any;
    @Prop() detailInfo: any;
    @Prop() workLoading: any;


    @Provide() private dialogVisible: Boolean = false;
    @Provide() private compRoleOptions: any = [];
    @Provide() private detailForm: any = {};

    //工作信息
    @Provide() private workForm: any = {
        employeeid:'',
        role:'',
        panelstatus:0,
    };
    @Provide() private rules: any =  {
        employeeid: [
            // { required: true, message: 'Required', trigger: 'change' },
            { max: 14, message: "the length have to be less than 15 letter", trigger: "blur" },
        ],
        role: [
            { required: true, message: 'Required', trigger: 'change' },
        ]
    };
    @Watch("detailInfo")
    onDetailInfoChanged(val: any) {
        if (val) {
            // this.workForm.employeeid = this.detailInfo.work.employeeid ? this.detailInfo.work.employeeid : this.baseUserInfo.employeeid
            // this.workForm.role = this.detailInfo.work.role ? this.detailInfo.work.role : this.baseUserInfo.common.usergroup

            // this.detailForm.employeeid = this.detailInfo.work.employeeid ? this.detailInfo.work.employeeid : this.baseUserInfo.employeeid
            // this.detailForm.role = this.detailInfo.work.role ? this.detailInfo.work.role : this.baseUserInfo.common.usergroup
            this.detailForm = JSON.parse(JSON.stringify(this.detailInfo.work))
            this.$forceUpdate()
            this.$emit('initForm',this.workForm,'3')
        }
    }
    private mounted () {
        this.ListUserGroupByType()
        // 如果新增进来，默认赋值，如果详情进来，先赋值，watch监听会改变其赋值为最新的值
        this.$nextTick(()=>{
            this.workForm.employeeid = this.baseUserInfo.employeeid
            this.workForm.role = this.baseUserInfo.common.usergroup
        })
        this.$emit('initForm',this.workForm,'3')

    }
    // submit
    private submitForm(formName:string){
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                this.workForm.panelstatus = 0
                this.$emit('submitForm',this.workForm,'3')
            } else {
                return false;
            }
        });
    }
    // reset
    private  resetForm(formName:string) {
        //此项两个值都不可以删除，reset也是重置到初始值
        let ref: any = this.$refs[formName];
        ref.resetFields();
        this.$emit('resetForm','3')
    }

    // show add
    private addInfo () {
        this.$emit('addForm','3')
    }

    // edit
    private editInfo () {
        this.workForm = JSON.parse(JSON.stringify(this.detailInfo.work))
        this.$emit('editForm','3')
    }


    private deleteInfo () {
        // 删除为假删除，实际该项不能删除
        this.dialogVisible = true
    }
    private cancelConfirm () {
        this.dialogVisible = false
    }
    private deleteConfirm () {
        this.dialogVisible = false
        this.$emit('deleteForm','3')
    }

    // 获取角色列表
    private ListUserGroupByType() {
        let request: any = new ListUserGroupByTypeReq();
        request.setCommonin(setCommon());
        request.setExectype(ExecType.EXEC_TYPE_URGE_INTERNAL);
        authorClient.listUserGroupByType(request, {}, (err: any, response: any) => {
            if (response) {
                let data: any = response.toObject();
                if (!data.commonout || data.commonout.code == 0) {
                    this.compRoleOptions = data.usergroupinfosList;
                } else if (data.code == 100100 || data.code == 100101) {
                    this.$router.push("./login");
                } else {
                    this.$message.error(data.commonout.errmsg);
                }
            }
            if (err) {
                errorMsg(err);
            }
        });
    }
}
